/**
 * 配送规则模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 获取配送规则列表
export const deliveryList = (params) => {
  return req.get('/delivery/rules/list', params);
}

// 新增配送规则
export const deliveryAdd = (params) => {
  return req.post('/delivery/rules', params);
}

// 修改配送规则
export const deliveryEdit = (params) => {
  return req.put('/delivery/rules', params);
}

// 获取配送规则详情
export const deliveryInfo = (deliveryRulesId) => {
  return req.get(`/delivery/rules/${deliveryRulesId}`);
}

// 根据配送规则计算价格
export const deliveryPrice = (params) => {
  return req.get('/delivery/rules/getPrice', params);
}

// 查询物流公司
export const getCompany = () => {
  return req.get('/delivery/rules/getCompany');
}

// 删除配送规则
export const deleteDeliveryRules = (ids) => {
  return req.delete(`/delivery/rules/${ids}`);
}

//查询订单快递信息
export const getOrderDelivery = (params) => {
  return req.get(`/order/payment/getOrderDelivery`, params);
}

//编辑配送信息
export const editDelivery = (params) => {
  return req.post(`/order/payment/editDelivery`, params);
}


